import React, { useEffect, useState } from "react";
import dummyCompanyLogo from "../../../../assets/dummyProfileImage.png";
import { FaLocationDot } from "react-icons/fa6";
import bagImage from "../../../../assets/bag-solid.png";
import cashMultiple from "../../../../assets/cash-multiple.png";
import { FaAngleLeft } from "react-icons/fa6";
import "./SimilarJob.css";
import { PaginationBtn } from "../../../component/ReUseComps/Button";
import { FaAngleRight } from "react-icons/fa";
import axios from "axios";
import { URLS } from "../../../../Utils/App_urls";
import { useNavigate, useParams } from "react-router-dom";
import { GoPlus } from "react-icons/go";
import { Oval } from "react-loader-spinner";
import { getJobPostedDate } from "../../../../Company/Component/CustomHook/jobPostedDate";
import Pagination from "../../../component/Pagination";

const formatDisplayUrl = (url) => {
  if (!url) return "N/A";

  try {
    const urlObj = new URL(url.startsWith("http") ? url : `https://${url}`);

    let displayUrl = urlObj.hostname.replace(/^www\./i, "");

    return displayUrl;
  } catch {
    let cleanedUrl = url
      .replace(/^https?:\/\//i, "")
      .replace(/^www\./i, "")
      .split("/")[0];
    return cleanedUrl || "N/A";
  }
};

const formatWebsiteUrl = (url) => {
  if (!url) return "#";
  return url.startsWith("http") ? url : `https://${url}`;
};

export default function SimilarJob() {
  const navigate = useNavigate();
  const paramId = useParams();
  const [allSimilarJobs, setAllSimilarJobs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const getSimillarJob = async (page = 1) => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${URLS.getAllJob}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        params: {
          page,
          limit: 10,
        },
      });
      console.log("similar job", response?.data);
      setAllSimilarJobs(response?.data?.result || []);
      setTotalPages(response?.data?.totalPages || 1);
      setCurrentPage(response?.data?.page || 1);
    } catch (err) {
      console.error("Error fetching similar jobs:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const convertHtmlToText = (htmlString) => {
    if (!htmlString) return "";
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlString;
    return tempElement.textContent || tempElement.innerText || "";
  };

  const redirectToJobDetails = (id) => {
    navigate(`/user/find-job/job-details/${id}`, {
      state: { DATA: id },
    });
  };

  useEffect(() => {
    getSimillarJob(currentPage);
  }, [currentPage]);

  if (isLoading) {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: "200px" }}
      >
        <Oval width="50" height="50" color="#3284FF" />
      </div>
    );
  }

  return (
    <div className="similar-job-main d-flex flex-column px-2 gap-2">
      {allSimilarJobs.length === 0 && !isLoading && (
        <div className="no-jobs-found">
          <p>No similar jobs found</p>
        </div>
      )}

      {allSimilarJobs.map((job, index) => {
        const companyWebUrl = formatWebsiteUrl(
          job?.companyProfileDetail?.[0]?.weburl
        );

        return (
          <div
            key={index}
            onClick={() => redirectToJobDetails(job?._id)}
            className={`similar-job-card d-flex flex-column gap-1 ${
              paramId?.id === job?._id && "active_similar_job"
            }`}
          >
            <div className="similar-job-header d-flex align-items-start justify-content-between flex-wrap">
              <div className="d-flex align-items-center gap-2">
                <div className="compy-logo-box">
                  <img
                    src={
                      job?.companyProfileDetail?.[0]?.companylogo ||
                      dummyCompanyLogo
                    }
                    alt={`${
                      job?.companyProfileDetail?.[0]?.companyName || "Company"
                    } logo`}
                    onError={(e) => {
                      e.target.src = dummyCompanyLogo;
                    }}
                  />
                </div>
                <div className="compy-title-descr">
                  <h1>{job?.title || "No title available"}</h1>
                  <p className="m-0">
                    {job?.companyProfileDetail?.[0]?.companyName || "N/A"}
                  </p>
                  {companyWebUrl && (
                    <a
                      href={companyWebUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {formatDisplayUrl(companyWebUrl)}
                    </a>
                  )}
                </div>
              </div>
              <p className="m-0">
                {getJobPostedDate(job?.createdAt?.split("T"))}
              </p>
            </div>

            <div className="compay-benif d-flex align-items-center justify-content-start flex-wrap gap-2">
              <div>
                <img src={bagImage} alt="Experience icon" />
                <span>{job?.experience || "N/A"}</span>
              </div>

              {job?.salaryType === "Fixed Salary" && (
                <div>
                  <img src={cashMultiple} alt="Salary icon" />
                  <span>{job?.FixedSalary || "0"} LPA</span>
                </div>
              )}

              {job?.salaryType === "Salary Range" && (
                <div>
                  <img src={cashMultiple} alt="Salary range icon" />
                  <span>
                    {job?.minSalary || "0"} - {job?.maxSalary || "0"} LPA
                  </span>
                </div>
              )}

              {job?.salaryType === "Not Disclose" && (
                <div>
                  <img src={cashMultiple} alt="Salary icon" />
                  <span>Not disclosed</span>
                </div>
              )}

              <div>
                <FaLocationDot fontSize={15} />
                <span>{job?.jobLocations || "N/A"}</span>
              </div>
            </div>

            <div className="highlight-skills d-flex align-items-center flex-wrap gap-2">
              {job?.skills?.slice(0, 3).map((skill, idx) => (
                <div key={idx}>{skill}</div>
              ))}
              {job?.skills?.length > 3 && (
                <div>
                  <GoPlus /> {job?.skills?.length - 3} More
                </div>
              )}
            </div>

            <div className="job-details-descrip">
              {job?.jobSummary ? (
                <>
                  {convertHtmlToText(job.jobSummary).slice(0, 120)}
                  {job.jobSummary.length > 120 && "..."}
                </>
              ) : (
                "No job summary available"
              )}
            </div>
          </div>
        );
      })}

      {allSimilarJobs.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      )}
    </div>
  );
}
